// App.js
import React, { Component } from 'react';
import { Container, Table, Row, Col, Input, Button } from 'reactstrap';
import * as XLSX from 'xlsx';

export class DriverRouteData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            metadata: [
                { label: 'Payment Week', value: '3/30/25 - 4/05/25' },
                { label: 'Check Date', value: '2025-04-11' }
            ],
            headers: [
                'Locations',
                'Name of Client',
                'Name of Routes',
                'First and Last',
                'Pay on Routes',
                'Total Route Count',
                'Total',
                'Comments on the Driver',
                'Transaction Type',
                'Live Check',
                'Day Run'
            ],
            data: [
                [
                    'WP/ALCT',
                    'WorldPac ATL Central',
                    'LB #1 ATL Central',
                    'John Doe',
                    '$200',
                    '5',
                    '$405',
                    'Great performance',
                    'Day Run',
                    '',
                    'Yes'
                ],
                [
                    'WP/NW',
                    'WorldPac Northwest',
                    'LB #2 Northwest',
                    'Jane Smith',
                    '$180',
                    '4',
                    '$320',
                    'Needs improvement',
                    'Night Run',
                    '',
                    'No'
                ]
            ]
        };
    }

    handleMetadataChange = (index, value) => {
        const metadata = [...this.state.metadata];
        metadata[index].value = value;
        this.setState({ metadata });
    };

    handleCellChange = (rowIndex, colIndex, value) => {
        const data = [...this.state.data];
        data[rowIndex][colIndex] = value;
        this.setState({ data });
    };

    addRow = () => {
        const { headers, data } = this.state;
        const newRow = Array(headers.length).fill('');
        this.setState({ data: [...data, newRow] });
    };

    removeRow = (rowIndex) => {
        const data = [...this.state.data];
        data.splice(rowIndex, 1);
        this.setState({ data });
    };

    saveToExcel = () => {
        const { metadata, headers, data } = this.state;

        // Prepare metadata rows
        const metaRows = metadata.map(item => [item.label, '', '', item.value]);

        // Prepare table rows
        const tableRows = [headers, ...data];

        // Combine into one sheet
        const sheetData = [...metaRows, [], tableRows[0], ...data];

        const ws = XLSX.utils.aoa_to_sheet(sheetData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Routes Data');

        XLSX.writeFile(wb, 'routes_data.xlsx');
    };

    render() {
        const { metadata, headers, data } = this.state;

        return (
            <Container className="mt-4">
                <h2>Editable Routes Data (Sample)</h2>

                {/* Metadata Section */}
                <Row className="mb-3">
                    {metadata.map((item, index) => (
                        <Col xs="12" md="6" key={index}>
                            <strong>{item.label}:</strong>{' '}
                            <Input
                                type="text"
                                value={item.value}
                                onChange={(e) => this.handleMetadataChange(index, e.target.value)}
                            />
                        </Col>
                    ))}
                </Row>

                {/* Action Buttons */}
                <div className="mb-3">
                    <Button color="success" onClick={this.addRow} className="mr-2">
                        Add Row
                    </Button>
                    <Button color="primary" onClick={this.saveToExcel}>
                        Save to Excel
                    </Button>
                </div>

                {/* Editable Table */}
                <Table bordered responsive>
                    <thead>
                        <tr>
                            {headers.map((head, i) => (
                                <th key={i}>{head}</th>
                            ))}
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {headers.map((_, colIndex) => (
                                    <td key={colIndex}>
                                        <Input
                                            type="text"
                                            value={row[colIndex] || ''}
                                            onChange={(e) =>
                                                this.handleCellChange(rowIndex, colIndex, e.target.value)
                                            }
                                        />
                                    </td>
                                ))}
                                <td>
                                    <Button
                                        color="danger"
                                        size="sm"
                                        onClick={() => this.removeRow(rowIndex)}
                                    >
                                        Remove
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Container>
        );
    }
}
